import { gql } from '@apollo/client'

export const CREATE_USER_LICENSE_PLATE = gql`
    mutation create_user_license_plate($request: CreateUserLicensePlateRequest!) {
        create_user_license_plate(request: $request) {
            id
        }
    }
`

// $plate: String!, $country: String!
